import axios from 'axios';
import baseUrl from '../config/baseURL';
import { getAuthToken } from '../services/auth';
import { LeadPatch } from '../pages/EditLeadDetailsPage';
import { count } from 'console';
import { Lead } from '../utils/types';

export const storeLeadsToLocal = (leads: any[]) => {
  try {
    localStorage.setItem('crm-leads', JSON.stringify(leads));
    return true;
  } catch (error) {
    console.error('Failed to store leads in localStorage:', error);
    return false;
  }
};

export const getLeadByIdFromLocal = async (id: any, orgId: any) => {
  const response = getLeadsFromLocal(orgId);
  console.log('Lead id ', id);
  console.log('orgId id ', orgId);

  if (response.success) {
    const leads = response.data;

    const lead = leads.find((lead: any) => {
      const match =
        lead.id.toString() === id.toString() &&
        lead.organization?.toString() === orgId.toString();

      return match;
    });
    if (lead) {
      return { success: true, data: lead };
    }
  }

  const fetched = await fetchLead(orgId, id);

  if (fetched.success && fetched.data) {
    return { success: true, data: fetched.data };
  }

  return { success: false, data: null };
};

export function updateLeadinLocalStorage(updatedLead: Lead): void {
  const leadsKey = 'crm-leads';

  // Safely parse leads from localStorage
  const stored = localStorage.getItem(leadsKey);
  const storedLeads: Lead[] = stored ? JSON.parse(stored) : [];

  // Replace existing lead by id
  const updatedLeads = storedLeads.map((lead) =>
    lead.id === updatedLead.id ? updatedLead : lead,
  );

  // Save back to localStorage
  localStorage.setItem(leadsKey, JSON.stringify(updatedLeads));
}

export const deleteLeadByIdFromLocal = (id: number, orgId: string) => {
  const response = getLeadsFromLocal(orgId);
  const leads = response?.data;
  const updatedLeads = leads?.filter((lead: any) => lead.id !== id);
  console.log(`deleting ${id} lead from local`);
  // console.log(`storing ${count(updatedLeads)} leads to local`);
  // console.log(`prev stored ${count(response?.data)} leads to local`);
  storeLeadsToLocal(updatedLeads);
  return updatedLeads;
};

export const storeSingleLeadToLocal = (lead: Lead, orgId: string) => {
  const response = getLeadsFromLocal(orgId);
  const leads = response?.data;
  const existingIndex = leads.findIndex((l: any) => l.id === lead.id);

  if (existingIndex !== -1) {
    leads[existingIndex] = lead;
  } else {
    leads.push(lead);
  }

  storeLeadsToLocal(leads);
  return true;
};

export const getInitialLeads = async (organization_id: string) => {
  console.log('Getting initial leads.');

  const local = getLeadsFromLocal(organization_id);
  const localLeadCount = local.success ? local.data.length : 0;
  console.log('localLeadCount', localLeadCount);
  console.log('local leads', local);
  try {
    const token = await getAuthToken();
    if (!token) {
      return { success: false, data: 'Token not available' };
    }
    const headers = {
      Authorization: `Bearer ${token.data}`,
    };

    const firstPageUrl = `${baseUrl}/core/organizations/${organization_id}/leads?page=1`;
    const response = await axios.get(firstPageUrl, { headers });

    if (response.status >= 200 && response.status <= 400) {
      const { count } = response.data;
      console.log('api lead count', count);

      if (local.success && localLeadCount === count) {
        return { success: true, data: local.data, source: 'local' };
      } else {
        const fullResponse = await fetchLeads(organization_id);

        if (fullResponse.success) {
          storeLeadsToLocal(fullResponse.data);
          return { success: true, data: fullResponse.data, source: 'fresh' };
        } else {
          return { success: false, data: fullResponse.data };
        }
      }
    } else {
      return { success: false, data: response?.data };
    }
  } catch (error) {
    console.error('Error in getInitialLeads:', error);
    return { success: false, data: error };
  }
};

export const fetchLeadsFromAPI = async (
  organization_id: string,
  nextPageUrl?: string,
) => {
  console.log('Fetching leads...');

  try {
    const token = await getAuthToken();
    if (!token || !token.data) {
      return { success: false, data: 'Token not available' };
    }

    const headers = {
      Authorization: `Bearer ${token.data}`,
    };

    // Decide which endpoint to call
    const endpoint = nextPageUrl
      ? nextPageUrl
      : `${baseUrl}/core/organizations/${organization_id}/leads/`;

    console.log('Fetching from:', endpoint);

    const response = await axios.get(endpoint, { headers });

    if (response.status >= 200 && response.status < 300) {
      const results = response.data;

      return {
        success: true,
        data: results,
      };
    }

    return { success: false, data: response.data || 'Unknown response error' };
  } catch (error: any) {
    console.error('Error fetching leads:', error);
    return { success: false, data: error.response?.data || error.message };
  }
};

export const getLeadsFromLocal = (orgId: string) => {
  console.log('Getting leads from local');

  try {
    let leadsData = localStorage.getItem('crm-leads');
    // leadsData =
    if (!leadsData) return { success: false, data: [] };

    const parsed = JSON.parse(leadsData);

    if (parsed[0]?.organization === orgId) {
      return { success: true, data: parsed };
    } else {
      localStorage.removeItem('crm-leads');
      return { success: false, data: [] };
    }
    // const data = localStorage.getItem("crm-leads");
    // return { success: true, data: data ? JSON.parse(data) : []};
  } catch (error) {
    console.error('Failed to retrieve leads from localStorage:', error);
    return {
      success: false,
      data: 'Failed to retrieve leads from localStorage:',
      error,
    };
  }
};

export const fetchLeads = async (organization_id: string, params: any = {}) => {
  console.log('Fetching leads from API with params:', params);
  const token = await getAuthToken();
  if (!token) return { success: false, data: 'Token does not exist' };

  const headers = { Authorization: `Bearer ${token.data}` };
  // let allResults: any[] = [];
  let nextUrl: string | null =
    `${baseUrl}/core/organizations/${organization_id}/leads/?page=1`;

  // Append search params to first request
  const query = new URLSearchParams(params).toString();
  if (query) nextUrl += `&${query}`;

  try {
    const response: any = await axios.get(nextUrl, { headers });
    if (response.status >= 200 && response.status < 300) {
      const { results, next } = response.data;
      nextUrl = next;
      return { success: true, data: response.data };
    } else {
      console.error('Pagination failed:', response);
      return { success: false, data: response.data };
    }
  } catch (error) {
    console.error('Error fetching leads:', error);
    return { success: false, data: error };
  }
};

export const fetchLeadsWithUrl = async (
  organization_id: string,
  url?: string | null,
  params: Record<string, any> = {},
) => {
  console.log('Fetching leads from API with params:', params);

  const token = await getAuthToken();
  if (!token) return { success: false, data: 'Token does not exist' };

  const headers = { Authorization: `Bearer ${token.data}` };

  // Determine the base URL to use
  let requestUrl =
    url || `${baseUrl}/core/organizations/${organization_id}/leads/`;

  // Append search params only if this is the initial fetch (not a pagination URL)
  if (!url && Object.keys(params).length > 0) {
    const query = new URLSearchParams(params).toString();
    requestUrl += `?${query}`;
  }

  try {
    const response = await axios.get(requestUrl, { headers });
    if (response.status >= 200 && response.status < 300) {
      const results = response.data;
      return {
        success: true,
        data: results,
      };
    } else {
      console.error('Error fetching leads:', response);
      return { success: false, data: response.data };
    }
  } catch (error) {
    console.error('Error fetching leads:', error);
    return { success: false, data: error };
  }
};

// export const fetchLeads = async (organization_id: any, params:any) => {
//   console.log('Fetching leads from api');
//   let token = await getAuthToken();
//   if (!token) {
//     return { success: false, data: "error: Token does not exist" };
//   }
//   const header_token = "Bearer " + token.data;
//   const headers = {
//     Authorization: header_token,
//   };
//   let allResults: any[] = [];
//   let nextUrl: string | null = `${baseUrl}/core/organizations/${organization_id}/leads`;

//   try {
//     while (nextUrl) {
//       const response:any = await axios.get(nextUrl, { headers });

//       if (response.status >= 200 && response.status <= 400) {
//         const { results, next } = response.data;
//         allResults = [...allResults, ...results];
//         nextUrl = next;
//       } else {
//         console.error("Pagination failed at response:", response);
//         return { success: false, data: response?.data };
//       }
//     }
//     return { success: true, data: allResults };
//   } catch (error) {
//     console.error("Unexpected error occurred while fetching leads:", error);
//     return { success: false, data: error };
//   }
// };

export const fetchLead = async (organization_id: any, lead_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/leads/${lead_id}`;
        const response = await axios.get(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          return { success: true, data: response?.data };
        } else {
          console.error('Data retrieval failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the leads:', error);
    return { success: false, data: undefined };
  }
};

export const deleteLead = async (organization_id: any, lead_id: any) => {
  let token = await getAuthToken();
  try {
    if (token) {
      let header_token = 'Bearer ' + token.data;
      const headers = {
        Authorization: header_token,
      };
      try {
        const endpoint = `${baseUrl}/core/organizations/${organization_id}/leads/${lead_id}/`;
        const response = await axios.delete(endpoint, { headers });
        if (response.status >= 200 && response.status <= 400) {
          deleteLeadByIdFromLocal(lead_id, organization_id);
          return { success: true, data: response?.data };
        } else {
          console.error('Data deletion failed here:', response, response.data);
          return { success: false, data: response?.data };
        }
      } catch (error) {
        console.error('An unexpected error occurred:', error);
        return { success: false, data: error };
      }
    } else {
      return { success: false, data: 'error: Token does not exist' };
    }
  } catch (error) {
    console.error('Unexpected error occurred while fetching the leads:', error);
    return { success: false, data: undefined };
  }
};

export const saveLead = async (
  company_id: string | null = null,
  orgId: string,
  title: string,
  first_name: string,
  second_name: string | null,
  email: string,
  phone: string,
  stage: string | null = 'new',
  level_of_interest: string | null = null,
  last_contacted: string | null = null,
  next_follow_up: string | null = null,
  customer: number | null = null,
  assigned_to: number | null = null,
) => {
  const leadData = {
    company_id,
    title,
    first_name,
    second_name,
    email,
    phone,
    stage,
    level_of_interest,
    last_contacted,
    next_follow_up,
    customer,
    assigned_to,
  };

  let token = await getAuthToken();
  let headers;

  if (token) {
    let header_token = 'Bearer ' + token.data;
    headers = {
      Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/leads/`;
    const response = await axios.post(endpoint, leadData, { headers });

    if (response.status === 201) {
      console.log('Lead created successfully:', response.data);
      storeSingleLeadToLocal(response?.data, orgId);
      return { success: true, data: response.data };
    } else {
      console.error('Failed to create lead:', response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error(
      'An unexpected error occurred:',
      error?.response?.data || error,
    );
    return { success: false, data: error?.response?.data || error };
  }
};

export const updateLeadDetail = async (
  orgId: string,
  leadId: any,
  detailName: string,
  detailData: string,
) => {
  const leadData = {
    [detailName]: detailData,
  };

  console.log('data', leadData);
  let token = await getAuthToken();
  let headers;

  if (token) {
    let header_token = 'Bearer ' + token.data;
    headers = {
      Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/leads/${leadId}/`;
    const response = await axios.patch(endpoint, leadData, { headers });

    if (response.status === 200) {
      console.log('Lead data updated successfully:', response.data);
      updateLeadinLocalStorage(response?.data);
      return { success: true, data: response.data };
    } else {
      console.error('Failed to update lead:', response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error(
      'An unexpected error occurred:',
      error?.response?.data || error,
    );
    return { success: false, data: error?.response?.data || error };
  }
};

export const updateLeadDetails = async (
  orgId: string,
  leadId: any,
  detailData: LeadPatch,
) => {
  const leadData = detailData;

  console.log('data', leadData);
  let token = await getAuthToken();
  let headers;

  if (token) {
    let header_token = 'Bearer ' + token.data;
    headers = {
      Authorization: header_token,
    };
  }

  try {
    const endpoint = `${baseUrl}/core/organizations/${orgId}/leads/${leadId}/`;
    const response = await axios.patch(endpoint, leadData, { headers });

    if (response.status === 200) {
      console.log('Lead data updated successfully:', response.data);
      updateLeadinLocalStorage(response?.data);
      return { success: true, data: response.data };
    } else {
      console.error('Failed to update lead:', response.data);
      return { success: false, data: response.data };
    }
  } catch (error: any) {
    console.error(
      'An unexpected error occurred:',
      error?.response?.data || error,
    );
    return { success: false, data: error?.response?.data || error };
  }
};
